/// <reference path="irep.js"/>

IREP.store = (function () {
    var bodyContainer = $("#contentContainer");
    var IsLoading = false;
    var init = function (options) {
        $(".product").click(toggleProduct);
        $("#productsListing").on("addProduct", ".product", addProductToCart);
        $("#eventsListing").on("addProduct", ".product", addProductToCart);
        $("#customerSupport").click(function (event) {
            event.preventDefault();
            IREP.master.contactUsToggle();
        });
    };

    var toggleProduct = function () {
        if (!IsLoading) {
            IsLoading = true;
            var productContainer = $(this);
            var existingProductContainer = $("#drawercontainer");
            var existingPopupId = existingProductContainer.data("product-id");
            var productId = productContainer.data("product-id");
            closeDrawer();


            if (existingPopupId !== productId) {
                loadProductDetail(productId, productContainer);
                IsLoading = false;
            } else {
                IsLoading = false;
            }
        }
        return false;
    };

    var closeDrawer = function () {
        $(".product.selected").removeClass("selected");
        $("#drawercurtain").filter(':not(:animated)').animate({ height: "450px" }, 400, function () {
            $("#drawecutrain").remove();
        });
        $("#drawercontainer").fadeOut("fast", function () {
            $(this).remove();
        });
        $("#overlay").fadeOut(400, function () { $(this).remove(); });
    };

    var loadProductDetail = function (productId, productContainer) {
        productContainer.addClass("selected");


        if (productContainer.find(".soldOutDetailsButton").length > 0) {
            var detailsButton = productContainer.find(".soldOutDetailsButton");
        } else if (productContainer.find(".purchasedDetailsButton").length > 0) {
            var detailsButton = productContainer.find(".purchasedDetailsButton");
        } else if (productContainer.find(".AddedtoCartButton").length > 0) {
            var detailsButton = productContainer.find(".AddedtoCartButton");
        } else {
            var detailsButton = productContainer.find(".detailsButton");
        }

        var drawerTemplate = Handlebars.compile($("#drawertemplate").html());
        var context = {
            productid: productId,
            "class": "productPopup container"
        };

        $(productContainer).append(drawerTemplate(context));

        var popup = productContainer.find($("#drawercontainer"))
            .click(function () {
                return false;
            });


        var borderWidth = parseInt($(".productPopup").css("border-top-width"), 10);
        popup.css({
            //top: detailsButton.offset().top + detailsButton.outerHeight() + borderWidth,
            //Setting this here as to not screw up the Events for now
            left: bodyContainer.offset().left,
            width: bodyContainer.width(),
            position: "fixed",
            bottom: 0
        });

        var drawer = IREP.drawer.init({
            template: popup,
            getUrl: productContainer.find("a").prop("href"),
            animateOnInit: true,
            useOverlay: true,
            animatePosition: "bottom",
            closeDrawer: closeDrawer,
            doneCallback: drawerInitDone
        });
    };

    var drawerInitDone = function () {
        $("#productInfo").find(".description").mCustomScrollbar({
            theme: 'dark-thick',
            scrollButtons: {
                enable: true
            }
        });
        $('form form').find('.aspNetHidden').remove(); //Clear viewstate for opera postback
    };

    var addProductToCart = function (event, data) {
        var form = $("#addProductContainer");
        form.find("#productId").val(data.productId);
        form.find("#optionId").val(data.optionId);
        var submitButton = form.find("#addProductSubmit");
        submitButton.trigger("click");
    };

    return {
        init: init,
        closeDrawer: closeDrawer
    };
})();

IREP.store.eventDetail = (function () {
    var optionsSelect;
    var optionElement;
    var optionId;
    var productId;

    var init = function (options) {
        optionsSelect = $("#addProduct").find("select");
        optionElement = $("#productOption");
        if (options.hasOptions) {
            optionsSelect.on("change", setOptionOptions);
            optionsSelect.trigger("change");
        } else {
            setPrice(options.price);
            setOptionId(options.optionId);
        }
        productId = $(".productPopup").data("product-id");
        $("#addButton").on("click", addProduct);

        var trainingsElement = $(".thumbnailWrapper");
        trainingsElement.on("click", function (e) {
            e.preventDefault();
            IREP.redirect(IREP.generateSiteLink("/quiz?code=" + $(this).attr('data-code')));
        }); 
    };

    var setOptionOptions = function () {
        var price = optionsSelect.find(":selected").data("price");
        var option = optionsSelect.find(":selected").data("option");
        setOptionId(option);
        setPrice(price);
    };

    var setPrice = function (price) {
        var priceContainer = $("#priceContainer");
        if (priceContainer.length > 0) {
            if ($("#itemAmount").length === 0) {
                priceContainer.html(priceContainer.html().replace("@@price@@", "<span id='itemAmount'>" + price + "</span>"));
            } else {
                $("#itemAmount").text(price);
            }
        }
    };

    var setOptionId = function (option) {
        optionElement.val(option);
        optionId = option;
    };

    var addProduct = function () {
        $(this).parents(".product").trigger("addProduct", {
            productId: productId,
            optionId: optionId
        });
    };

    return {
        init: init
    };
})(); 

IREP.store.productDetail = (function () {
    var optionsSelect;
    var optionElement;
    var productId;
    var optionId;
    var sold;
    var store = IREP.store;

    var init = function (options) {

        optionsSelect = $("#addProduct").find("select");
        optionElement = $("#productOption");
        if (options.hasOptions) {
            optionsSelect.on("change", setOptionOptions);
            optionsSelect.trigger("change");
        } else {
            setPrice(options.price);
            setOptionId(options.optionId);
            setEntries(options.sold);
        }
        productId = $(".productPopup").data("product-id");
        $("#addButton").on("click", addProduct);
        $("#hasOrderedButton").on("click", store.closeDrawer);
        $("#verificationLink").on("click", function(e) {
            e.preventDefault();
            IREP.redirect(IREP.generateSiteLink("/verification"));
        });

        $("#dashboardLink").on("click", function(e) {
            e.preventDefault();
            IREP.redirect(IREP.generateSiteLink("/dashboard"));
        });

        $(".addButtonContainer").hover(function () {
            $(this).css({ "cursor": "pointer" });
        });
    };

    var setOptionOptions = function () {
        var price = optionsSelect.find(":selected").data("price");
        var option = optionsSelect.find(":selected").data("option");
        var entry = optionsSelect.find(":selected").data("sold");
        setOptionId(option);
        setPrice(price);
        setEntries(entry);
    };

    var setPrice = function (price) {
        var priceContainer = $("#priceContainer");
        if (priceContainer.length > 0) {
            if ($("#itemAmount").length === 0) {
                priceContainer.html(priceContainer.html().replace("@@price@@", "<span id='itemAmount'>" + price + "</span>"));
            } else {
                $("#itemAmount").text(price);
            }
        }
    };

    var setEntries = function (sold) {
        var entriesContainer = $("#entriesContainer");
        if (entriesContainer.length > 0) {
            if ($("#itemEntry").length === 0) {
                entriesContainer.html(entriesContainer.html().replace("@@sold@@", "<span id='itemEntry'>" + sold + "</span>"));
            } else {
                $("#itemEntry").text(sold);
            }
        }
    }

    var setOptionId = function (option) {
        optionElement.val(option);
        optionId = option;
    };

    var addProduct = function () {
        $(this).parents(".product").trigger("addProduct", {
            productId: productId,
            optionId: optionId
        });
    };

    return {
        init: init
    };
})();

IREP.store.cart = (function () {
    var init = function (options) {
        $("#updateCart").click(function (e) {
            e.preventDefault();
            UpdateCart(false);
        });

        $("#checkout").click(function (e) {
            e.preventDefault();
            UpdateCart(true);
        });
    };

    var UpdateCart = function (isCheckingOut) {
        var items = [];
        $(".productRow").each(function () {
            var that = $(this);
            var optionId = that.data("optionid");
            var price = that.find($(".unitprice")).val();
            //If delete is checked then set the new quantity to 0, the service will know what to do with it.
            var newQuantity = parseInt(that.find("#Quantity").val());

            if (that.find(".delete").is(":checked") || newQuantity <= 0) {
                newQuantity = 0;
            }

            var item = {
                productOptionId: optionId,
                quantity: newQuantity,
                unitPrice: price
            };
            items.push(item);
        });

        var options = {
            url: "store/cart/processupdate", type: "POST", data: { cart: { items: items } }
        };

        IREP.callApi(options).done(function (data) {
            if (isCheckingOut) {
                Checkout(data);
            } else if (data.isChanged || data.errors.length > 0) {
                RebindCart(data);
            }
        });

        if ($("#errorList").children().length > 0) {
            $("#errorList").children().remove();
            $("#checkoutSpan").show();
        }
    };

    var RebindCart = function (data) {
        var cart = data.newCart;
        var itemLength = cart.items.length;

        if (data.errors.length > 0) {
            DisplayErrors(data.errors);
        } else {
            if ($("#errorList").children().length > 0) {
                $("#errorList").children().remove();
            }
        }

        if (itemLength > 0) {
            $(".productRow").remove();
            var html = "";
            for (var i = 0; i < itemLength; i++) {
                var item = cart.items[i];
                var template = Handlebars.compile($("#productRow").html());
                var context = { optionid: item.productOptionId, name: item.name, attribute: item.attribute != null ? item.attribute : "N/A", price: FormatPrice(item.unitPrice), quantity: item.quantity, limit: item.limit > 0 ? "max=" + item.limit + "" : "", disabled: IREP.options.user.geoCode == "ASMO" ? "" : "disabled" };
                html += template(context);
            }
            $("#ShoppingCartTotal").text(FormatPrice(cart.totalCost));
            $("#infoRow").before(html);
        } else {
            IREP.redirect(IREP.generateSiteLink("/store"));
        }
    };

    var Checkout = function (data) {
        if (data.newCart.totalCost < IREP.options.user.chipCount) {
            IREP.redirect(IREP.generateSiteLink("/store/checkout"));
        } else {
            var errorMessage = "<li>You do not have enough ";
            errorMessage += "credits"
            errorMessage += " to checkout. </li>";
            $("#errorList").append(errorMessage);
            $("#errorList").show();
        }
    };

    var DisplayErrors = function (errors) {
        $("#errorList").children().remove();
        for (var i = 0, len = errors.length; i < len; i++) {
            $("#errorList").append("<li>" + errors[i] + "</li>");
        }
    };
    var FormatPrice = function (price) {
        var parts = price.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return parts.join(".");
    };

    return {
        init: init
    };
})();

IREP.store.checkOut = (function () {
    var init = function (options) {
        var countryDropDown = $("#country");
        var stateDropDown = $("#State");
        FillStateDropDown(countryDropDown.val());
        countryDropDown.on("change", function () {
            FillStateDropDown(countryDropDown.val());
        });
        stateDropDown.on("change", function () {
            $("#StateValue").val($("#State option:selected").val());
        });
        $("#cancel").click(function (e) {
            e.preventDefault();
            IREP.redirect(IREP.generateSiteLink("/store"));
        });

        $("#orderButton").click(function (e) {
            e.preventDefault();
            if (checkRequired()) {
                $("#orderButton").off('click');
                BuildOrder();
            }
        });
    };

    var BuildOrder = function () {

        IREP.callApi({ url: "/store/cart/get" }).done(function (data) {
            var cart = data.cart;
            if (cart != null && cart.items.length > 0) {
                var firstName = $("#txtFirstName").val();
                var lastName = $("#txtLastName").val();
                var phone = $("#txtPhone").val();
                var address1 = $("#txtAddress1").val();
                var address2 = $("#txtAddress2").val();
                var country = $("#country :selected").val();
                var state = $("#StateValue").val();
                var city = $("#txtCity").val();
                var zip = $("#txtPostal").val();

                var order = {
                    FirstName: firstName,
                    LastName: lastName,
                    Country: country,
                    Address: address1,
                    Address2: address2,
                    Phone: phone,
                    City: city,
                    State: state,
                    Zip: zip
                };

                var options = { url: "order/placedbcartorder", type: "POST", secure: false, data: { Order: order } };
                IREP.callApi(options).done(function(data) {
                    if (data.isValidCart) {
                        if ($("#errorList").children().length > 0) {
                            $("#errorList").children().remove();
                        }
                        $("#orderform").css("visibility", "hidden");
                        $("#orderconfirm").show(400);

                        IREP.callApi({ url: "/store/cart/delete", type: "POST" });
                    } else {
                        DisplayErrors(data.errors);
                    }
                }).fail(function() {
                    $("#errorList").append("<li> There was an error processing your cart</li>");
                    $("#orderButton").on('click');
                });
            } else {
                $("#errorList").append("<li>Your cart has expired. Please return to the store and add your items again</li>");
                $("#orderButton").on('click');
            }
        });
    };

    var checkRequired = function () {
        var b = true;
        var regexPhone = (IREP.options.user.geoCode === "ASMO" ? /^\(?\d\d\d\)?(\s+|-)?\(?\d\d\d?\)?(\s+|-)?\(?\d\d\d\d\)?$/ : /^\(?\d\d\)?(\s+|-)?\(?\d\d\d\d\d?\)?(\s+|-)?\(?\d\d\d\d\)?$/);
        var phone = $("#txtPhone").val();

        // check required fields
        $(".error").remove();
        $('input[required="required"]').each(function (i, v) {
            if ((this.getAttribute("data-message") != null) && ((this.getAttribute("disabled") != "disabled") && (this.getAttribute("disabled") != true))) {
                var msg = "<div id='error" + i + "' class='error'>" + this.getAttribute("data-message") + "</div>";
                if (v.value == "") {
                    $(this).after(msg);
                    b = false;
                } else {
                    $("#error" + i).remove();
                }
            }
        });

        //phone regex check
        if ((phone.match(regexPhone) == null) && (phone.length > 0) && (IREP.options.user.geoCode !== "PRC") && (IREP.options.user.geoCode !== "EMEA") && (IREP.options.user.geoCode !== "APAC")) {
            if (IREP.options.user.geoCode === "ASMO") {
                $("#txtPhone").after("<div id='phError' class='error'>&nbsp;* (###) ###-####</div>");
            }
            else { 
                    $("#txtPhone").after("<div id='phError' class='error'>&nbsp;* ## ####-####</div>"); 
            }
            b = false;
        } else {
            $("#phError").remove();
        }
         
        return b;
    };

    var DisplayErrors = function (errors) {
        $("#errorList").children().remove();
        for (var i = 0, len = errors.length; i < len; i++) {
            $("#errorList").append("<li>" + errors[i] + "</li>");
        }

        $("#orderbutton").on("click");
    };

    var FillStateDropDown = function (countryCode) {
        IREP.callApi("country/states/" + countryCode, "GET").done(function (data) {
            $("#State").children().remove();
            if (data.states.length > 0) {
                $("#State").show();
                $("#State").siblings().show();
                for (var i = 0; i < data.states.length; i++) {
                    var state = data.states[i];
                    var $dropOption = $("<option>", {
                        "value": state.id,
                        "text": state.name
                    });
                    $("#State").append($dropOption);
                }
                $("#StateValue").val($("#State option:first").val());
                $("#StateId").val($("#State option:first").val());
            } else {
                $("#State").hide();
                $("#State").siblings().hide();
                $("#StateValue").val('');
                $("#StateId").val('0');
            }
        });
    };
    return {
        init: init
    };
})();